import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { isAgentActionRoute as isAgentActionRouteMatcher } from './app-routing.matchers';
import { AdministratorGuard } from './features/administrator/guards/administrator.guard';
import { AgentManagerGuard } from './features/agent-manager/guards/agent-manager.guard';
import { AgentPreferenceGuard } from './features/agent-preferences/guards/agent-preference.guard';
import { AgentSupervisorGuard } from './features/agent-supervisor/guards/agent-supervisor.guard';
import { AgentGuard } from './features/agent/guards/agent.guard';
import { LeadInjectorGuard } from './features/lead-injector/guards/lead-injector.guard';
import { LeadManagerGuard } from './features/lead-manager/guards/lead-manager.guard';
import { AuthenticationGuard } from './shared/authentication/authentication.guard'
import { LoginPageComponent } from './shared/pages/login-page/login-page.component';
import { UnauthorizedPageComponent } from './shared/pages/unauthorized-page/unauthorized-page.component';

export enum AppRoute {
  administrator = 'administrator',
  agent = 'lead-board',
  agentpreferences = 'preferences',
  agentmanager = 'lead-struttura',
  agentsupervisor = 'lead-monitor',
  leadmanager = 'gestione-lead',
  leadinjector = 'lead-injectors',
  unauthorized = 'unauthorized',
  loginPopup = 'loginPopup'
}

const routes: Routes = [
  { path: AppRoute.unauthorized, component: UnauthorizedPageComponent },
  { path: AppRoute.loginPopup, component: LoginPageComponent },

  { path: AppRoute.agent, loadChildren: () => import('./features/agent/agent.module').then(m => m.AgentModule), canLoad: [AgentGuard] },
  { matcher: isAgentActionRouteMatcher, loadChildren: () => import('./features/agent/agent.module').then(m => m.AgentModule), canLoad: [AgentGuard] },
  { path: AppRoute.agentpreferences, loadChildren: () => import('./features/agent-preferences/agent-preferences.module').then(m => m.AgentPreferencesModule), canLoad: [AgentPreferenceGuard] },
  { path: AppRoute.agentmanager, loadChildren: () => import('./features/agent-manager/agent-manager.module').then(m => m.AgentManagerModule), canLoad: [AgentManagerGuard] },
  { path: AppRoute.agentsupervisor, loadChildren: () => import('./features/agent-supervisor/agent-supervisor.module').then(m => m.AgentSupervisorModule), canLoad: [AgentSupervisorGuard] },
  { path: AppRoute.leadmanager, loadChildren: () => import('./features/lead-manager/lead-manager.module').then(m => m.LeadManagerModule), canLoad: [LeadManagerGuard] },
  { path: AppRoute.leadinjector, loadChildren: () => import('./features/lead-injector/lead-injector.module').then(m => m.LeadInjectorModule), canLoad: [LeadInjectorGuard] },
  { path: AppRoute.administrator, loadChildren: () => import('./features/administrator/administrator.module').then(m => m.AdministratorModule), canLoad: [AdministratorGuard] }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    initialNavigation: !(window !== window.parent && !window.opener) ? 'enabledNonBlocking' : 'disabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
